import React from "react";
import moment from "moment";
import Highcharts from "highcharts";
import HorizontalBarComp from "../HorizontalBar.component";
import HelpTextComp from "../../../components/helper/helptext.component";
import GoalProgressBar from "../../../components/okr/okr_depend_components/goalProgressBar.component";
import OrgResultChart from "./OrgResultGraph";
import "./chart.scss";
import { useTranslation } from 'react-i18next';
import { imgUrl } from '../../../utils/url';

const getGraphOptions = (props: any, graphData, t) => {
  //const { t } = useTranslation();
  const startMonth = moment(props.selectedValue.split("-")[0].split("/"));
  const endMonth = moment(props.selectedValue.split("-")[1].split("/"));
  // let cat = [`${startMonth.format("MMM")} 1`, `${startMonth.add(1, "M").format("MMM")} 1`, `${startMonth.add(1, "M").format("MMM")} 1`, `${startMonth.endOf("month").format("MMM")} ${startMonth.endOf("month").format("DD")}`  ]

 
  let series1=[["0",0]], series2=[["0",0]], series3=[["0",0]];
  $.each(graphData.selectedTeam, function (index, value) {
    series1.push([value.period, value.value]);
  });

  $.each(graphData.allTeams, function (index, value) {
    series2.push([value.period, value.value]);
  });

  $.each(graphData.pastData, function (index, value) {
    series3.push([value.period, value.value]);
  });
  const  options:any = {
    chart: {
      type: "line",
    },
    title: {
      text: '',
      style: {
          display: 'none'
      }
    },
    subtitle: {
        text: '',
        style: {
            display: 'none'
        }
    },
    yAxis: {
        title: {
            text: `${t('Results')} achievement`,
            x: 5,
        },
        type: 'linear',
        lineWidth:1,
        lineColor: "#8b929b",
        gridLineWidth: 0,
        labels: {
          align: 'right',
          enabled: true,
          x: 20,
          formatter: function() {
            if (this.isLast ) {
              return '100%';
            }
            if(this.isFirst){
              return '0%';
            }
          }
        },
        max: 100,
        min: 0
    },
    xAxis: {
        // accessibility: {
        //     rangeDescription: `Range: ${graphData.xAxisLabels[0]} to ${graphData.xAxisLabels[graphData.xAxisLabels.length-1]}`
        // },
        //range: 3 * 30 * 24 * 3600 * 1000,
        type: 'datetime',
        gridLineWidth: 0,
        lineColor: "#8b929b",
        // width: "100%",
        categories: graphData.xAxisLabels,
        tickWidth: 0,
        max: graphData.xAxisLabels.length-1,
        labels: {
          rotation: 0,
          style:{
            fontSize: "9px",
            whiteSpace: "nowrap",
            textOverflow: "inherit"
          },
        },
        plotLines: [{
          color: 'rgba(204, 204, 204, 0.5)',
          width: 1,
          value: graphData.selectedTeam.length // Position, you'll have to translate this to the values on your x axis
      }]
    },
    credits: {
      enabled: false
    },
    legend: {
        // align: 'right',
        // verticalAlign: 'top',
        layout: 'vertical',
        marker: {
          symbol: "circle"
        },
        itemStyle: {
          width: 150,
          textOverflow: "ellipsis",
        },
        symbolWidth: 12,
        symbolHeight: 12,
        symbolRadius: 10,
        squareSymbol: true,
        labelFormatter: function () {
          return this.name;
      }
    },
    plotOptions: {
        series: {
            label: {
                connectorAllowed: false
            },
            stickyTracking: false,
            pointPlacement: 'on',
            marker: {
              symbol: "circle",
              radius: 2.5
            }
        },
        line: {
          data: {
            marker: {
              symbol: "circle"
            }
          }
        }
    },
    exporting: {
      enabled: false
    },

    tooltip: {
      backgroundColor: "#707172",
      borderColor: "#707172",
      borderWidth: 2,
      borderRadius: 4,
      padding: 6,
      snap: 0,
      className: "chart-tooltip",
      style: {
        color: "#ffffff",
        fontFamily: "Lato",
        fontSize: "12px",
        fontWeight: "normal"
      },
      formatter: function () {
        if(this.point.name != "0"){
          return '<p>' + this.key +
            ' - ' + this.y + '%</p>';
        }
        return false;
      }
    },
    series: [{
        name: props.objKey["okr"],
        data: series1,
        color: props.plotKeyColorMapping["okr"],
      }, 
      {
          name: props.objKey["aggregate"],
          data: series2,
          color: props.plotKeyColorMapping["aggregate"],
      },
      {
        name: props.pQuaterName,
        data: series3,
        dashStyle: 'Dot',
        color: "#CCCCCC",
        showInLegend: graphData.pastData.length ? true : false,
      }
    ],

    responsive: {
        rules: [{
            condition: {
                maxWidth: "100%",
            },
        }]
    }
  };
  return options;
};

const getStyle = (count, length): any => {
  if( count === length){
    return {
      position: "relative"
    }
  }else{
    return {};
  }
}

const ResultComparisonComp = (props: any) => {
  const { t } = useTranslation();
  const {QTDResults, directReporteeLists, teamProgress, plotKeyColorMapping,cQuaterName} = props;
  let emptyListCounts = [0]
  if(QTDResults && QTDResults !== null) {
  QTDResults.forEach((result, i) => {
    let empty = 0;
    result.orgResultDirectReporteeTeam.forEach((t) => {
      let team = directReporteeLists.find((teamData) => teamData.id == t.id);
      if(team){
        t.name = team.name;
        t.owner_name = team.owner_name;
        if(t.progress === null){
          empty += 1;
        }
      }
    })
    emptyListCounts[i]= empty;
  })
  }
  
  return (
    <div className="resultSpreadWrapper orgResultsCard">
      <div className="orgResultsCard_header">
        <div className="orgResultsCard_header_title">
          {`${cQuaterName} ${t('Results Comparison by Objective')}`}
        </div>
      </div>
      {/* <div className="header">
          <div className="org-result-overview_header">
              
          </div>
        </div> */}
      {
       QTDResults !==null && QTDResults.map((okr, i) => (
          <div className="orgResultsCard_main" key={`${i}-okr`}>
            <div className="orgResultsCard_main_title">
              {okr.name}
            </div>
            <section className="orgResultsCard_main_left resultComparison">
              <div className="section-header comparison">
                  {`${t('Objective progress for org and team')}`}
              </div>
              <div className="section-visuals">
                <OrgResultChart container="chart" widthC={props.widthC} options= {getGraphOptions(props, okr.graphData, t)} key={`${props.objKey["okr"]}-${props.selectedValue}`} />
              </div>
            </section>
            <section className="orgResultsCard_main_right resultComparison" style={getStyle(emptyListCounts[i], okr.orgResultDirectReporteeTeam.length)}>
              <div className="section-header comparison">
                  {t('Progress for direct reports’ teams')}
                  {/* <span className="helptextIcon icon icon-outline-help_outline-14px" title=></span> */}
                  <HelpTextComp popUpClass="leftAlign">
                    {`${t('Progress for the teams led by')} ${props.forData.userName} ${t('direct reports on their aligned OKRs')}`}
                  </HelpTextComp>
              </div>
              <div className="section-visuals">
                {
                  okr.orgResultDirectReporteeTeam.map((team) => 
                    <div key={`${i}-${team.id}-reportee`}>
                      <div className="section-visuals_title fixedWidth" title={!team.progress && team.progress !== 0 ? `${team.name} ${('team led by')} ${team.owner_name} ${t('does not have an aligned OKR')}` : `${team.name}` }>
                        <a href={`/wb/goal/teamGoal?teamId=${team.id}`} target="_blank" style={{color: "inherit"}}>
                            {team.name}
                        </a> 
                      </div>
                      <div className="section-visuals_graph">
                        {
                          team.progress !== null && team.progress >= 0 ?
                          <GoalProgressBar
                          percentage={team.progress}
                          color={'#8185a1'}
                          title={`${team.name} ${t('team led by')} ${team.owner_name} ${t('has made')} ${team.progress}% ${t('progress on their aligned OKR')}`}
                          style={{
                            width: "calc(100% - 50px)",
                            marginTop: "0px",
                            fontSize: 12,
                            lineHeight: "10px"
                          }}
                          />
                          : emptyListCounts[i] !== okr.orgResultDirectReporteeTeam.length ? <span style={{float: "right", marginRight: "12px"}}>N/A</span> : ""
                        }
                      </div>
                    </div>
                  )      
                }
                {
                emptyListCounts[i] === okr.orgResultDirectReporteeTeam.length &&
                <div className={`emptyVisual ${(window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/')  > -1) ? "IE": ""}`}>
                  <div>
                    <img src={imgUrl('/images/okr-empty.png')} alt={t('OKR Empty')}/>
                  </div>
                  <div className="cont">
                    {`${t('None of the teams have an OKR aligned to this Objective theme')}`}
                  </div>
                </div>
                }
              </div> 
            </section>
          </div>
        ))
      }
    </div>
  );
}

export default React.memo(ResultComparisonComp);
